import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { TextField } from 'seagull';
import { positiveQuantityInputProps } from '~/constants';
import { connectControllerToTextField } from '~/utils/react-hook-form.utils';
export default function MinPriceTextField(param) {
    let { onChange = ()=>{}, testId } = param;
    const { control, watch, trigger } = useFormContext();
    const [pricing, price] = watch([
        'pricing',
        'price'
    ]);
    useEffect(()=>{
        trigger('minPrice');
    }, [
        pricing,
        price
    ]);
    return /*#__PURE__*/ _jsx(Controller, {
        control: control,
        name: "minPrice",
        rules: {
            validate: (minPrice)=>{
                if (minPrice && +minPrice < 0) {
                    return 'Insert a non-negative min price';
                }
                if (minPrice && price && +minPrice >= +price) {
                    return "Min can't exceed or equal max";
                }
            }
        },
        render: (renderProps)=>{
            const connectedProps = connectControllerToTextField(renderProps);
            return /*#__PURE__*/ _jsx(TextField, _object_spread_props(_object_spread({
                isMoney: true,
                alwaysShrinkLabel: true,
                inputProps: positiveQuantityInputProps,
                label: "Min price (optional)",
                prefix: "$",
                testId: testId
            }, connectedProps), {
                onChange: (e)=>{
                    connectedProps.onChange(e);
                    onChange(e.target.value);
                }
            }));
        }
    });
}
